import { ACTION } from './ac_central_actions';
import {
  list_reducer,
  add_reducer,
  update_reducer,
  delete_reducer,
  add_to_list_reducer,
  update_in_list_reducer,
  delete_in_list_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  totalCount: null,
  filteredCount: null,
  isLoading: false,
  isCreating: false,
  isEditing: false,
  isDeleting: false,
  isDuplicating: false,
  isChillerAdding: false,
  isChillerEditing: false,
  isChillerRemoving: false,
  isWaterPumpAdding: false,
  isWaterPumpEditing: false,
  isWaterPumpRemoving: false,
  isCoolingTowerAdding: false,
  isCoolingTowerEditing: false,
  isCoolingTowerRemoving: false,
  isAirHandlingUnitAdding: false,
  isAirHandlingUnitEditing: false,
  isAirHandlingUnitRemoving: false,
  errorMessage: null,
  ToBeCreatedWaterPump: [],
  ToBeCreatedChiller: [],
  ToBeCreatedCoolingTower: [],
  ToBeCreatedAirHandlingUnit: [],
};

export default (state = initialState, action) => {
  const CHILLER_KEY = 'chiller_list';
  const WATER_PUMP_KEY = 'water_pump_list';
  const COOLING_TOWER_KEY = 'cooling_tower_list';
  const AIR_HANDLING_UNIT_KEY = 'fan_coil_list';

  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isLoading: false,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isCreating: false,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT}_PENDING`:
      return {
        ...state,
        isEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isEditing: false,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_REJECTED`:
      return {
        ...state,
        isEditing: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        isDeleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        isDeleting: false,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        isDeleting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DUPLICATE}_PENDING`:
      return {
        ...state,
        isDuplicating: true,
        errorMessage: null,
      };
    case `${ACTION.DUPLICATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isDuplicating: false,
        errorMessage: null,
      };
    case `${ACTION.DUPLICATE}_REJECTED`:
      return {
        ...state,
        isDuplicating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.ADD_CHILLER}_PENDING`:
      return {
        ...state,
        isChillerAdding: true,
        errorMessage: null,
      };
    case `${ACTION.ADD_CHILLER}_FULFILLED`:
      return {
        ...state,
        ...add_to_list_reducer(state, action.payload.ac_central_id, action.payload, CHILLER_KEY),
        isChillerAdding: false,
        errorMessage: null,
      };
    case `${ACTION.ADD_CHILLER}_REJECTED`:
      return {
        ...state,
        isChillerAdding: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT_CHILLER}_PENDING`:
      return {
        ...state,
        isChillerEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT_CHILLER}_FULFILLED`:
      return {
        ...state,
        ...update_in_list_reducer(state, action.payload.ac_central_id, action.payload, CHILLER_KEY),
        isChillerEditing: false,
        errorMessage: null,
      };
    case `${ACTION.EDIT_CHILLER}_REJECTED`:
      return {
        ...state,
        isChillerEditing: false,
        errorMessage: action.payload,
      };

    case `${ACTION.REMOVE_CHILLER}_PENDING`:
      return {
        ...state,
        isChillerRemoving: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_CHILLER}_FULFILLED`:
      return {
        ...state,
        ...delete_in_list_reducer(state, action.payload.ac_central_id, action.payload.id, CHILLER_KEY),
        isChillerRemoving: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_CHILLER}_REJECTED`:
      return {
        ...state,
        isChillerRemoving: false,
        errorMessage: action.payload,
      };

    case `${ACTION.ADD_WATER_PUMP}_PENDING`:
      return {
        ...state,
        isWaterPumpAdding: true,
        errorMessage: null,
      };
    case `${ACTION.ADD_WATER_PUMP}_FULFILLED`:
      return {
        ...state,
        ...add_to_list_reducer(state, action.payload.ac_central_id, action.payload, WATER_PUMP_KEY),
        isWaterPumpAdding: false,
        errorMessage: null,
      };
    case `${ACTION.ADD_WATER_PUMP}_REJECTED`:
      return {
        ...state,
        isWaterPumpAdding: false,
        errorMessage: action.payload,
      };

    case `${ACTION.EDIT_WATER_PUMP}_PENDING`:
      return {
        ...state,
        isWaterPumpEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT_WATER_PUMP}_FULFILLED`:
      return {
        ...state,
        ...update_in_list_reducer(state, action.payload.ac_central_id, action.payload, WATER_PUMP_KEY),
        isWaterPumpEditing: false,
        errorMessage: null,
      };
    case `${ACTION.EDIT_WATER_PUMP}_REJECTED`:
      return {
        ...state,
        isWaterPumpEditing: false,
        errorMessage: action.payload,
      };

    case `${ACTION.REMOVE_WATER_PUMP}_PENDING`:
      return {
        ...state,
        isWaterPumpRemoving: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_WATER_PUMP}_FULFILLED`:
      return {
        ...state,
        ...delete_in_list_reducer(state, action.payload.ac_central_id, action.payload.id, WATER_PUMP_KEY),
        isWaterPumpRemoving: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_WATER_PUMP}_REJECTED`:
      return {
        ...state,
        isWaterPumpRemoving: false,
        errorMessage: action.payload,
      };

    case `${ACTION.ADD_COOLING_TOWER}_PENDING`:
      return {
        ...state,
        isCoolingTowerAdding: true,
        errorMessage: null,
      };
    case `${ACTION.ADD_COOLING_TOWER}_FULFILLED`:
      return {
        ...state,
        ...add_to_list_reducer(state, action.payload.ac_central_id, action.payload, COOLING_TOWER_KEY),
        isCoolingTowerAdding: false,
        errorMessage: null,
      };
    case `${ACTION.ADD_COOLING_TOWER}_REJECTED`:
      return {
        ...state,
        isCoolingTowerAdding: false,
        errorMessage: action.payload,
      };

    case `${ACTION.EDIT_COOLING_TOWER}_PENDING`:
      return {
        ...state,
        isCoolingTowerEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT_COOLING_TOWER}_FULFILLED`:
      return {
        ...state,
        ...update_in_list_reducer(state, action.payload.ac_central_id, action.payload, COOLING_TOWER_KEY),
        isCoolingTowerEditing: false,
        errorMessage: null,
      };
    case `${ACTION.EDIT_COOLING_TOWER}_REJECTED`:
      return {
        ...state,
        isCoolingTowerEditing: false,
        errorMessage: action.payload,
      };

    case `${ACTION.REMOVE_COOLING_TOWER}_PENDING`:
      return {
        ...state,
        isCoolingTowerRemoving: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_COOLING_TOWER}_FULFILLED`:
      return {
        ...state,
        ...delete_in_list_reducer(state, action.payload.ac_central_id, action.payload.id, COOLING_TOWER_KEY),
        isCoolingTowerRemoving: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_COOLING_TOWER}_REJECTED`:
      return {
        ...state,
        isCoolingTowerRemoving: false,
        errorMessage: action.payload,
      };

    case `${ACTION.ADD_AIR_HANDLING_UNIT}_PENDING`:
      return {
        ...state,
        isAirHandlingUnitAdding: true,
        errorMessage: null,
      };
    case `${ACTION.ADD_AIR_HANDLING_UNIT}_FULFILLED`:
      return {
        ...state,
        ...add_to_list_reducer(state, action.payload.ac_central_id, action.payload, AIR_HANDLING_UNIT_KEY),
        isAirHandlingUnitAdding: false,
        errorMessage: null,
      };
    case `${ACTION.ADD_AIR_HANDLING_UNIT}_REJECTED`:
      return {
        ...state,
        isAirHandlingUnitAdding: false,
        errorMessage: action.payload,
      };

    case `${ACTION.REMOVE_AIR_HANDLING_UNIT}_PENDING`:
      return {
        ...state,
        isAirHandlingUnitRemoving: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_AIR_HANDLING_UNIT}_FULFILLED`:
      return {
        ...state,
        ...delete_in_list_reducer(state, action.payload.ac_central_id, action.payload.id, AIR_HANDLING_UNIT_KEY),
        isAirHandlingUnitRemoving: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_AIR_HANDLING_UNIT}_REJECTED`:
      return {
        ...state,
        isAirHandlingUnitRemoving: false,
        errorMessage: action.payload,
      };

    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
      };
    case `${ACTION.ADD_TO_BE_CREATED_WATER_PUMP}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedWaterPump: [...state.ToBeCreatedWaterPump, action.payload],
        errorMessage: null,
      };
    case `${ACTION.ADD_TO_BE_CREATED_WATER_PUMP}_REJECTED`:
      return {
        ...state,
        isWaterPumpAdding: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT_TO_BE_CREATED_WATER_PUMP}_PENDING`:
      return {
        ...state,
        isWaterPumpEditing: true,
        };
    case `${ACTION.EDIT_TO_BE_CREATED_WATER_PUMP}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedWaterPump: state.ToBeCreatedWaterPump.map(
          rel => rel.water_pump.id === action.payload.id ? {...rel, quantity: action.payload.quantity} : rel
        ),
        isWaterPumpEditing: false,
      };
    case `${ACTION.REMOVE_TO_BE_CREATED_WATER_PUMP}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedWaterPump: state.ToBeCreatedWaterPump.filter(
          rel => rel.water_pump.id !== action.payload.id
        ),
      };
    case `${ACTION.ADD_TO_BE_CREATED_CHILLER}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedChiller: [...state.ToBeCreatedChiller, action.payload],
        errorMessage: null,
      };
    case `${ACTION.ADD_TO_BE_CREATED_CHILLER}_REJECTED`:
      return {
        ...state,
        isChillerAdding: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT_TO_BE_CREATED_CHILLER}_PENDING`:
      return {
        ...state,
        isChillerEditing: true,
        };
    case `${ACTION.EDIT_TO_BE_CREATED_CHILLER}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedChiller: state.ToBeCreatedChiller.map(
          rel => rel.chiller.id === action.payload.id ? {...rel, quantity: action.payload.quantity} : rel
        ),
        isChillerEditing: false,
      };
    case `${ACTION.REMOVE_TO_BE_CREATED_CHILLER}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedChiller: state.ToBeCreatedChiller.filter(
          rel => rel.chiller.id !== action.payload.id
        ),
      };
    case `${ACTION.ADD_TO_BE_CREATED_COOLING_TOWER}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedCoolingTower: [...state.ToBeCreatedCoolingTower, action.payload],
        errorMessage: null,
      };
    case `${ACTION.ADD_TO_BE_CREATED_COOLING_TOWER}_REJECTED`:
      return {
        ...state,
        isCoolingTowerAdding: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT_TO_BE_CREATED_COOLING_TOWER}_PENDING`:
      return {
        ...state,
        isCoolingTowerEditing: true,
        };
    case `${ACTION.EDIT_TO_BE_CREATED_COOLING_TOWER}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedCoolingTower: state.ToBeCreatedCoolingTower.map(
          rel => rel.cooling_tower.id === action.payload.id ? {...rel, quantity: action.payload.quantity} : rel
        ),
        isCoolingTowerEditing: false,
      };
    case `${ACTION.REMOVE_TO_BE_CREATED_COOLING_TOWER}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedCoolingTower: state.ToBeCreatedCoolingTower.filter(
          rel => rel.cooling_tower.id !== action.payload.id
        ),
      };
    case `${ACTION.ADD_TO_BE_CREATED_AIR_HANDLING_UNIT}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedAirHandlingUnit: [...state.ToBeCreatedAirHandlingUnit, action.payload],
        errorMessage: null,
      };
    case `${ACTION.ADD_TO_BE_CREATED_AIR_HANDLING_UNIT}_REJECTED`:
      return {
        ...state,
        isAirHandlingUnitAdding: false,
        errorMessage: action.payload,
      };
    case `${ACTION.REMOVE_TO_BE_CREATED_AIR_HANDLING_UNIT}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedAirHandlingUnit: state.ToBeCreatedAirHandlingUnit.filter(
          rel => rel.fan_coil.id !== action.payload.id 
        ),
      };
    case `${ACTION.CLEAR_AC_CENTRAL}_FULFILLED`:
      return {
        ...state,
        ToBeCreatedWaterPump: [],
        ToBeCreatedChiller: [],
        ToBeCreatedCoolingTower: [],
        ToBeCreatedAirHandlingUnit: [],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ac_central/ac_central_reducer.js